import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Observable } from 'rxjs/Observable';
// Modelos
import { Pendiente } from '../../../models/pendiente';
// Servicios
import { CatalogosService } from '../../../services/catalogos.service';
import { UsuariosPersonalService } from '../../../services/usuarios-personal.service';
import { PendientesService } from '../../../services/pendientes.service';

@Component({
    templateUrl: './crear-pendiente.component.html'
})

export class CrearPendienteComponent implements OnInit {

    // Objeto para la creación del pendiente
    pendiente:Pendiente = new Pendiente();

    // Usuario Actual
    private currentUser:any;

    // Catálogos
    departamentos:Observable<any>;
    responsables:Observable<any>;

    constructor(
        private usuariosPersonalService:UsuariosPersonalService,
        private pendientesService:PendientesService,
        private location:Location,
        private catalogosService: CatalogosService){
    }
    
    // Función de OnInit
    ngOnInit(){
        this.currentUser = this.usuariosPersonalService.auth;
        // Se obtienen los datos de los catálogos
        this.departamentos = this.catalogosService.obtenerDepartamentos().valueChanges();
    }

    crearPendiente(){
        // Inicializa el objeto pendiente
        this.pendiente.creador = this.currentUser.uid;
        
        this.pendientesService.crearPendiente(this.pendiente)
        .then(() => {
            this.pendiente = new Pendiente();
            alert('El pendiente fue creado con éxito');
        });
    }

    // crearPrimerNota(pendiente){
    //     if (this.notas != "" && this.notas != undefined) {
    //     let currentdate = new Date();
    //         let mensaje = {
    //             remitente: this.currentUser.uid,
    //             fecha: currentdate.getTime(),
    //             contenido: this.notas
    //         }
    //        this.afDB.list('pendientes/' + pendiente.key + '/notas').push(mensaje);
    //     }
    // }
    // crearNotificacionResponsable(responsables, pendiente){        
    //     responsables.forEach(responsable => {
    //         if(this.currentUser.uid != responsable){
    //             this.afDB.object('notificacionesPorUsuario/'+ responsable +'/'+ pendiente.key).set(
    //                 {
    //                     redireccion:'?pendientes?ventas?detalle-pendiente?' + pendiente.key,
    //                      tipo:'pendiente Asignado',
    //                      usuarioEmisior:this.currentUser.uid
    //                 });
    //         }            
    //     });        
    // }
    
    // // creamos el pendiente dentro de pendiente por creador y en pendiente por responsable
    // crearPendientesPorCreadorResponsable(pendiente:any){
    //     this.afDB.object('pendientesPorCreador/' + this.pendiente.creador + '/' + pendiente.key)
    //     .set(true);
    //     if(this.pendiente.responsable){
    //     this.afDB.object('pendientesPorResponsable/' + this.pendiente.responsable + '/' + pendiente.key)
    //     .set(true);
    //     }else{
    //         let responsablesDB = '';
    //        for (let index in this.responsables){
    //             let responsable:any = this.responsables[index];
    //             this.afDB.object('pendientesPorResponsable/' + responsable.$key + '/' + pendiente.key)
    //                 .set(true);
    //              responsablesDB += ',' +responsable.$key;
    //         }
    //         //this.af.database.object('pendientes/'+ pendiente.key).update({responsables:this.responsables});
    //     }

    //     // Mensaje de éxito en la creación
    //     alert('El pendiente fue creado con éxito');

    //     this.location.back();
    // }

    cambiarDepartamento(departamento){
        this.responsables = this.usuariosPersonalService.obtenerUsuariosDepartamento(departamento).snapshotChanges().take(1)
        .map(responsables => {
            let responsablesArr = [];
            responsables.forEach(responsable => {
                const $key = responsable.payload.key;
                const data = { $key, ...responsable.payload.val() };
                responsablesArr.push(data);
            });
            return responsablesArr;
        });
    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/crear-pendiente/crear-pendiente.component.ts